import api from '@/common/api';


export const GenericInputMixin = {
  props: {
    id: {
      required: false,
      type: String,
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    helpText: {
      type: String,
    },
    label: {
      default() {
        return null;
      },
    },
    labelCount: {
      type: Number,
      default() {
        return 1;
      },
    },
    placeholder: {
      default() {
        return '';
      },
    },
    required: {
      default() {
        return false;
      },
    },
    small: {
      default() {
        return false;
      },
    },
    translateText: {
      default() {
        return true;
      },
    },
  },
};


export const GenericListMixin = {
  // This mixin allows a component to behave as a list of objects
  // (objectList). This can be any list of object, depending on
  // the "apiPath" that is set on the component;
  data() {
    return {
      objectList: [], // List of objects retrieved from the get request;
      totalObjects: 0, // Total number of objects;
      searchQuery: '', // String search
      loading: false, // Indicates whether the request is pending for the response;
      nextPageUrl: null, // The url for the next page (pagination);
      getObjectsOnCreated: true, // list starts with first page on creation of component;
    };
  },
  created() {
    if (this.getObjectsOnCreated) {
      this.getObjects();
    }
  },
  methods: {
    getQueryParams() {
      const params = this.getParams();
      if (this.searchQuery) {
        params.search = this.searchQuery;
      }
      return params;
    },
    filterObjects(query) {
      this.searchQuery = query;
      this.getObjects();
    },
    async getObjects(url = null, append = false) {
      this.loading = true;

      await this.preProcess();

      const response = url ? await api.get(url) : await api.get(
        this.apiPath,
        this.getQueryParams(),
      );
      if (response.status !== 200) {
        this.loading = false;
        return;
      }
      const objectList = response.data.results || response.data;
      this.totalObjects = response.data.count;

      if (append) {
        this.objectList = this.objectList.concat(objectList);
      } else {
        this.objectList = objectList;
      }

      this.setNextPageUrl(response.data.next);
      this.loading = false;
      this.postProcess();
    },
    getParams() {
      // Abstract method that adds params to the list endpoint request;
      // to be overridden by the child component;
      return {};
    },
    setNextPageUrl(url) {
      this.nextPageUrl = null;
      if (url) {
        const urlObject = new URL(url);
        this.nextPageUrl = `${urlObject.pathname}${urlObject.search}`;
      }
    },
    async preProcess() {
      // a hook triggered before data fetching;
    },
    postProcess() {
      // a hook triggered after the data is fetched from the API;
    },
    reset() {
      if (this.getObjectsOnCreated) {
        this.searchQuery = '';
        this.getObjects();
      } else {
        this.searchQuery = '';
        this.objectList = [];
      }
    },
  },
};

export const GenericDetailMixin = {
  data() {
    return {
      apiPath: null,
      object: null,
      objectName: null,
    };
  },
  methods: {
    getApiPath() {
      // eslint-disable-next-line no-throw-literal
      throw 'function "getApiPath" is not implemented';
    },
    async getObject() {
      const response = await api.get(this.getApiPath());
      this.object = response.data;
      if (this.objectName) {
        this[this.objectName] = this.object;
      }
      this.postProcess();
    },
    postProcess() {
      // a hook triggered after the data is fetched from the API;
    },
  },
  async created() {
    await this.getObject();
  },
};


export const GenericFormMixin = {
  data() {
    return {
      apiPath: null,
      apiMethod: 'post',
      errors: {},
      loader: {
        loading: false,
      },
      data: null,
    };
  },
  computed: {
    apiCall() {
      if (this.apiMethod === 'put') {
        return api.put;
      }
      if (this.apiMethod === 'patch') {
        return api.patch;
      }
      return api.post;
    },
  },
  methods: {
    copyData() {
      return JSON.parse(JSON.stringify(this.data));
    },
    postProcess() {
      // a hook triggered after the data is fetched from the API;
    },
    preProcess() {
      // a hook triggered before the the interaction with the API;
      // a returns a copy of the data;
      return this.copyData();
    },
    getApiPath() {
      return this.apiPath;
    },
    makeFormData(data) {
      const formData = new FormData();
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }
      return formData;
    },
    async submit() {
      this.loader.loading = true;
      this.errors = {};

      const data = this.preProcess();

      const response = await this.apiCall(
        this.getApiPath(),
        this.makeFormData(data),
      );

      if (response.status === 400) {
        this.errors = response.data;
        this.loader.loading = false;
        return;
      }

      this.postProcess(response);
      this.loader.loading = false;
    },
  },
};


export const OrganisationMixin = {
  computed: {
    bgOrganisation() {
      // eslint-disable-next-line global-require
      let path = require('@/common/assets/img/bg_organisation.jpg');
      if (this.organisation.type === 'media_agency') {
        // eslint-disable-next-line global-require
        path = require('@/common/assets/img/bg_media_agency.jpg');
      }
      return path;
    },
    bannerStyle() {
      const bg = 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))';
      let imagePath = this.bgOrganisation;
      if (this.organisation.banner) {
        imagePath = this.organisation.banner;
      }
      return { 'background-image': `${bg}, url('${imagePath}')` };
    },
  },
};
